export type GridCell = {
  x: number;
  y: number;
  src: string;
  properties: string[];
};

export type Grid = GridCell[][];

type Rules = {};

type Settings = {
  rules: Rules;
  name: string;
  id: string;
};

export interface GameConfig {
  grid: Grid;
  settings: Settings;
}

export interface ModifiedGameConfig {
  grid: string;
  settings: Settings;
}

export type Coord = {
  x: number;
  y: number;
};

export type FRank = {
  f: number;
  x: number;
  y: number;
};

export type CellNode = {
  g: number;
  h: number;
  f: number;
  parentCol: number;
  parentRow: number;
};

export interface Path {
  coords: Coord[];
  moveDirection: number;
  currentPosition: number;
};

export enum RESOURCE_TYPES {
  ORE = 1,
  TIMBER,
}
